import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { PBService } from '../pocketbase.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private pb: PBService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // If trying to access login page while authenticated
    if (route.routeConfig?.path === 'login') {
      if (this.pb.isAuthenticated()) {
        this.router.navigate(['/menus']);
        return false;
      }
      return true;
    }

    if (this.pb.isAuthenticated()) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
